<template>
  <div class="news">
    <div class="news_content">
      <div class="news_content_img"><img :src="newsObj.img" :title="newsObj.title" :alt="newsObj.title"></div>
      <div class="news_content_left">
        <ul>
          <li :class="newsObj.id === item.id ? 'selectStyle': ''" v-for="item in records" :key="item.id" @click="getNewsDetail(item.id)">{{item.title}}</li>
        </ul>
      </div>
      <div class="news_content_right" v-html="newsObj.content">
      </div>
    </div>
  </div>

</template>

<script>
import {
  getNewsTypeList,
  getNewsDetails
} from "@/api/api";
  export default{
    name:'News',
    data () {
      return {
        newsObj: {},
        records:[],
      }
    },
    methods: {
      getNewsTypeList(param) {
        getNewsTypeList(param).then(res => {
          if(res.data.code === 0) {
            this.records = res.data.data.records;
          }
        })
      },
      getNewsDetails(id) {
        getNewsDetails(id).then(res => {
          if(res.data.code === 0) {
            this.newsObj = res.data.data;
          }
        })
      },
      getNewsDetail(id) {
        this.getNewsDetails(id)
      }
    },
    mounted() {
       const param = {
        pageCurrent: 1,
        pageSize: 20,
        "qp-typeId-eq": 1
      };
      this.getNewsTypeList(param);
      this.getNewsDetails(this.$route.query.newsId)
    }
  }
</script>

<style>
.news{width: 1000px;margin: 0 auto}
.news_content{}
.news_content_left{width: 200px;background-color: #ebebeb; color: #000000;margin: 10px 0 50px 0;float: left}
.news_content_left ul{text-align: center}
.news_content_left ul li{line-height: 50px;cursor: pointer}
.news_content_right{width: 800px;float: left;padding: 0 15px;box-sizing: border-box;}
.news_content_img{width: 1000px}
.news_content_img img{width: 100%}
.news_content_left ul li.active{ background-color: rgb(0, 0, 0);   
      color: rgb(255, 255, 255); }
 .selectStyle{    color: rgb(235, 235, 235);background-color: rgb(0, 0, 0)}
</style>
